import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Weddingcarrenatalinbelgaum() {



    const cardData = {




keyword: "Wedding Car Rental in Belgaum",

headingDescription: "Belgaum Taxi Service provides elegant and reliable wedding car rental in Belgaum for bride and groom transportation, family travel, guest transfers, engagement ceremonies, reception events, and destination weddings. We offer a wide range of premium and comfortable vehicles including luxury sedans, SUVs, Innova Crysta, Fortuner, Kia Carens, and other premium cars to make your special occasion memorable. Our wedding car rental services include beautifully maintained vehicles, professional chauffeurs, timely pickup and drop, flexible rental packages, and customized arrangements according to your wedding schedule. Whether you need a luxury car for the wedding couple or multiple vehicles for family and guests, Belgaum Taxi Service ensures a comfortable and stylish travel experience. We provide wedding transportation solutions across Belgaum, nearby cities, resorts, banquet halls, and destination wedding locations with a focus on punctuality, safety, and premium service quality.",

topPlaces: [
  {
    title: "The Orchard Resort Belagavi",
    description: "The Orchard Resort is a popular wedding and event destination near Belgaum, offering spacious venues and beautiful surroundings for celebrations and family functions."
  },
  {
    title: "Hotel Eefa Belagavi",
    description: "Hotel Eefa is a well-known venue in Belgaum for weddings, receptions, corporate events, and family gatherings, requiring comfortable guest transportation services."
  },
  {
    title: "Maratha Mandir",
    description: "Maratha Mandir is a popular event venue in Belgaum used for weddings, cultural programs, and social functions. Wedding car rental services provide convenient transportation for guests."
  },
  {
    title: "Angol",
    description: "Angol is a prominent residential area in Belgaum with many family functions and celebrations. Premium wedding cars are commonly required for special occasions here."
  },
  {
    title: "Tilakwadi",
    description: "Tilakwadi is one of Belgaum's established localities with residential communities, hotels, and event spaces suitable for wedding transportation services."
  },
  {
    title: "Goa",
    description: "Goa is a popular destination wedding location known for beaches, luxury resorts, and grand celebrations. Premium wedding car rentals from Belgaum provide comfortable travel for couples and guests."
  },
  {
    title: "Kolhapur",
    description: "Kolhapur is a nearby city known for traditional weddings, temples, and cultural celebrations. Wedding car services help families travel comfortably between Belgaum and Kolhapur."
  },
  {
    title: "Pune",
    description: "Pune is a major wedding and event destination with luxury hotels, resorts, and banquet venues. Premium vehicles are preferred for wedding guests and family transportation."
  },
  {
    title: "Mahabaleshwar",
    description: "Mahabaleshwar is a scenic hill station known for resorts and destination weddings. Luxury car rentals offer comfortable travel for couples and wedding groups."
  },
  {
    title: "Bangalore",
    description: "Bangalore offers numerous luxury hotels, wedding venues, and event spaces. Wedding car rentals are suitable for premium ceremonies and guest transportation."
  }
],




"services": [
  {
    "name": "Wedding Car Rental in Belgaum",
    "description": "Book Wedding Car Rental in Belgaum for a stylish and memorable wedding transportation experience. Choose from luxury sedans, premium SUVs, Innova Crysta, Ertiga, Force Urbania, and other comfortable vehicles for bride entry, groom entry, guest transportation, and wedding events. Enjoy decorated cars, professional chauffeurs, punctual service, and customized wedding travel solutions."
  },
  {
    "name": "Wedding Car Hire in Belgaum",
    "description": "Hire Wedding Car in Belgaum for elegant and comfortable travel on your special day. Our luxury wedding cars are available for marriage ceremonies, receptions, pre-wedding events, and guest transfers with experienced drivers, premium interiors, and reliable service."
  },
  {
    "name": "Wedding Car on Rent in Belgaum",
    "description": "Rent Wedding Car in Belgaum for premium wedding transportation with beautifully maintained vehicles and professional chauffeurs. We provide luxury cars for bride pickup, groom arrival, family travel, and complete wedding transportation requirements."
  },
  {
    "name": "Luxury Wedding Car Rental Belgaum",
    "description": "Experience Luxury Wedding Car Rental Belgaum with premium vehicles designed to make your wedding celebration special. Choose luxury cars with comfortable seating, stylish appearance, professional drivers, and personalized rental packages."
  },
  {
    "name": "Bridal Car Rental Belgaum",
    "description": "Book Bridal Car Rental Belgaum for a grand and comfortable bride entry. Our luxury bridal cars provide elegant interiors, clean presentation, decorated options, and professional chauffeur services for a memorable wedding arrival."
  },
  {
    "name": "Wedding Cab Service Belgaum",
    "description": "Choose Wedding Cab Service Belgaum for complete wedding transportation solutions. From bride and groom movement to guest pickup and drop, we provide reliable vehicles with experienced drivers and flexible booking options."
  },
  {
    "name": "Wedding Car Booking Belgaum",
    "description": "Complete Wedding Car Booking Belgaum easily with premium vehicle options for your special occasion. Book luxury sedans, SUVs, and premium cars with professional drivers for smooth and stress-free wedding travel."
  },
  {
    "name": "Online Wedding Car Booking Belgaum",
    "description": "Book Online Wedding Car Booking Belgaum for quick reservations and hassle-free wedding transportation planning. Select your preferred luxury vehicle, rental duration, and travel requirements with convenient booking support."
  },
  {
    "name": "Premium Wedding Car Belgaum",
    "description": "Choose Premium Wedding Car Belgaum for stylish wedding arrivals and luxury transportation. Our premium vehicles offer comfort, elegance, spacious interiors, and professional service for unforgettable wedding celebrations."
  },
  {
    "name": "Luxury Car Rental for Wedding Belgaum",
    "description": "Book Luxury Car Rental for Wedding Belgaum for royal-style wedding transportation. Get premium cars for bride entry, groom entry, ceremonies, receptions, and VIP guest travel with experienced chauffeurs."
  },
  {
    "name": "Wedding Vehicle Rental Belgaum",
    "description": "Choose Wedding Vehicle Rental Belgaum for complete transportation arrangements including luxury cars, SUVs, Innova Crysta, Ertiga, Tempo Traveller, and Urbania vehicles for weddings and events."
  },
  {
    "name": "Bride Entry Car Rental Belgaum",
    "description": "Make your wedding entrance special with Bride Entry Car Rental Belgaum. Select elegant and decorated wedding cars with professional drivers to create a memorable arrival experience."
  },
  {
    "name": "Groom Entry Car Rental Belgaum",
    "description": "Book Groom Entry Car Rental Belgaum for a grand wedding arrival. Our premium vehicles provide stylish appearance, comfortable rides, and reliable chauffeur-driven service."
  },
  {
    "name": "Marriage Car Rental Belgaum",
    "description": "Get Marriage Car Rental Belgaum services for traditional and modern wedding functions. We provide luxury cars, family vehicles, and guest transportation options with affordable packages."
  },
  {
    "name": "Wedding Luxury Car Hire Belgaum",
    "description": "Hire Wedding Luxury Car Belgaum for premium wedding celebrations. Enjoy luxury vehicles, comfortable interiors, professional drivers, and personalized transportation services for your special event."
  },
  {
    "name": "Decorated Wedding Car Belgaum",
    "description": "Book Decorated Wedding Car Belgaum for beautiful wedding entries and celebrations. Choose customized decoration options with premium vehicles and professional chauffeur service."
  },
  {
    "name": "Wedding Sedan Rental Belgaum",
    "description": "Choose Wedding Sedan Rental Belgaum for comfortable and affordable wedding transportation. Our sedan cars are ideal for bride entry, groom travel, family movement, and guest transfers."
  },
  {
    "name": "Wedding SUV Rental Belgaum",
    "description": "Book Wedding SUV Rental Belgaum for spacious and premium wedding travel. SUVs provide comfort, style, and reliability for family members, VIP guests, and special occasions."
  },
  {
    "name": "Wedding Innova Crysta Rental Belgaum",
    "description": "Hire Wedding Innova Crysta Rental Belgaum for luxury family transportation and guest movement. Enjoy premium seating, spacious luggage capacity, and comfortable travel with professional drivers."
  },
  {
    "name": "Wedding Ertiga Rental Belgaum",
    "description": "Book Wedding Ertiga Rental Belgaum for affordable and comfortable group travel. Ideal for family members, wedding guests, and event transportation with reliable chauffeur services."
  },
  {
    "name": "Wedding Force Urbania Belgaum",
    "description": "Choose Wedding Force Urbania Belgaum for premium group transportation during wedding events. Perfect for guest pickup, family travel, and luxury group movement with AC comfort and spacious seating."
  },
  {
    "name": "Wedding Tempo Traveller Belgaum",
    "description": "Book Wedding Tempo Traveller Belgaum for comfortable transportation of wedding guests and groups. Enjoy AC vehicles, spacious seating, professional drivers, and smooth travel arrangements."
  },
  {
    "name": "Best Wedding Car Rental Belgaum",
    "description": "Choose Best Wedding Car Rental Belgaum for reliable luxury vehicles, professional chauffeurs, affordable packages, and premium transportation services for your wedding celebration."
  },
  {
    "name": "Cheap Wedding Car Rental Belgaum",
    "description": "Book Cheap Wedding Car Rental Belgaum for budget-friendly wedding transportation without compromising comfort and quality. Get well-maintained vehicles with experienced drivers at affordable prices."
  },
  {
    "name": "Top Wedding Car Hire Belgaum",
    "description": "Choose Top Wedding Car Hire Belgaum for premium wedding vehicles, timely service, and professional transportation solutions. We provide customized options for every wedding requirement."
  },
  {
    "name": "Affordable Luxury Wedding Cars Belgaum",
    "description": "Get Affordable Luxury Wedding Cars Belgaum for elegant wedding travel at competitive prices. Choose from premium cars with comfortable interiors and professional chauffeur services."
  },
  {
    "name": "Premium Wedding Transportation Belgaum",
    "description": "Book Premium Wedding Transportation Belgaum for complete event travel management. We provide luxury cars, guest transportation, family vehicles, and professional drivers for smooth wedding arrangements."
  },
  {
    "name": "Luxury Bridal Car Rental Belgaum",
    "description": "Choose Luxury Bridal Car Rental Belgaum for a beautiful and memorable bridal entry. Our premium vehicles ensure comfort, elegance, and a royal wedding experience."
  },
  {
    "name": "Executive Wedding Car Service Belgaum",
    "description": "Book Executive Wedding Car Service Belgaum for VIP wedding transportation. Enjoy premium vehicles, professional chauffeurs, punctual service, and comfortable travel arrangements."
  },
  {
    "name": "Royal Wedding Vehicle Belgaum",
    "description": "Hire Royal Wedding Vehicle Belgaum for a grand wedding experience. Select premium cars and luxury vehicles to add elegance and style to your special occasion."
  },
  {
    "name": "Trusted Wedding Car Rental Belgaum",
    "description": "Choose Trusted Wedding Car Rental Belgaum for dependable wedding transportation with experienced drivers, clean vehicles, flexible packages, and professional service."
  },
  {
    "name": "Luxury Marriage Car Booking Belgaum",
    "description": "Book Luxury Marriage Car Booking Belgaum for premium wedding travel solutions. Get elegant cars, luxury vehicles, professional chauffeurs, and customized transportation for marriage functions."
  }
],

"tableData": [
  ["Wedding Car Rental in Belgaum", "Wedding Car Hire in Belgaum"],
  ["Wedding Car on Rent in Belgaum", "Luxury Wedding Car Rental Belgaum"],
  ["Bridal Car Rental Belgaum", "Wedding Cab Service Belgaum"],
  ["Wedding Car Booking Belgaum", "Online Wedding Car Booking Belgaum"],
  ["Premium Wedding Car Belgaum", "Luxury Car Rental for Wedding Belgaum"],
  ["Wedding Vehicle Rental Belgaum", "Bride Entry Car Rental Belgaum"],
  ["Groom Entry Car Rental Belgaum", "Marriage Car Rental Belgaum"],
  ["Wedding Luxury Car Hire Belgaum", "Decorated Wedding Car Belgaum"],
  ["Wedding Sedan Rental Belgaum", "Wedding SUV Rental Belgaum"],
  ["Wedding Innova Crysta Rental Belgaum", "Wedding Ertiga Rental Belgaum"],
  ["Wedding Force Urbania Belgaum", "Wedding Tempo Traveller Belgaum"],
  ["Best Wedding Car Rental Belgaum", "Cheap Wedding Car Rental Belgaum"],
  ["Top Wedding Car Hire Belgaum", "Affordable Luxury Wedding Cars Belgaum"],
  ["Premium Wedding Transportation Belgaum", "Luxury Bridal Car Rental Belgaum"],
  ["Executive Wedding Car Service Belgaum", "Royal Wedding Vehicle Belgaum"],
  ["Trusted Wedding Car Rental Belgaum", "Luxury Marriage Car Booking Belgaum"]
],





whychoose: [
  {
    WhyChooseheading: "Premium Wedding Car Rental in Belgaum",
    WhyChoosedescription: "Belgaum Taxi Service offers elegant wedding car rental services with luxury vehicles, professional chauffeurs, and stylish transportation for your special day."
  },
  {
    WhyChooseheading: "Luxury Cars for Grand Wedding Entry",
    WhyChoosedescription: "Make your wedding arrival memorable with premium cars that add elegance, comfort, and a royal touch to your celebration."
  },
  {
    WhyChooseheading: "Wide Range of Wedding Cars",
    WhyChoosedescription: "Choose from premium sedans, SUVs, Innova Crysta, luxury vehicles, and spacious cars suitable for bride-groom entry and guest transportation."
  },
  {
    WhyChooseheading: "Decorated Wedding Cars Available",
    WhyChoosedescription: "Get beautifully decorated wedding cars with attractive floral arrangements and customized decoration options for your special occasion."
  },
  {
    WhyChooseheading: "Professional Chauffeur Service",
    WhyChoosedescription: "Our experienced drivers provide punctual, courteous, and comfortable service while ensuring a smooth wedding travel experience."
  },
  {
    WhyChooseheading: "Wedding Guest Transportation",
    WhyChoosedescription: "Arrange comfortable transportation for family members, guests, and wedding groups with reliable cars and multiple vehicle options."
  },
  {
    WhyChooseheading: "Flexible Wedding Rental Packages",
    WhyChoosedescription: "Select hourly, daily, and event-based wedding car rental packages according to your ceremony schedule and requirements."
  },
  {
    WhyChooseheading: "24/7 Booking Support",
    WhyChoosedescription: "Plan your wedding transportation anytime with quick booking confirmation and dedicated assistance for a stress-free experience."
  }
]

};

const faqData = [
  {
    question: "Does Belgaum Taxi Service provide Wedding Car Rental in Belgaum?",
    answer: "Yes, we provide wedding car rental services in Belgaum with premium vehicles, professional drivers, and customized packages."
  },
  {
    question: "Which cars are available for wedding rental?",
    answer: "We offer various options including premium sedans, SUVs, Innova Crysta, and luxury vehicles based on your wedding requirements."
  },
  {
    question: "Can I book a decorated wedding car?",
    answer: "Yes, decorated wedding cars with floral arrangements and stylish designs are available for bride-groom entry and special events."
  },
  {
    question: "Do you provide cars for bride and groom entry?",
    answer: "Yes, our wedding cars are suitable for grand bride and groom arrivals, ceremonies, receptions, and photo sessions."
  },
  {
    question: "Can I hire wedding cars for guest transportation?",
    answer: "Yes, we provide comfortable vehicles for transporting wedding guests, family members, and groups."
  },
  {
    question: "Is chauffeur service included with wedding car rental?",
    answer: "Yes, professional chauffeurs are provided to ensure safe, comfortable, and timely transportation."
  },
  {
    question: "Can I rent a wedding car for a full day?",
    answer: "Yes, full-day and event-based wedding car rental packages are available according to your schedule."
  },
  {
    question: "Are decoration charges included in wedding car rental?",
    answer: "Decoration charges depend on the selected package and customization requirements."
  },
  {
    question: "Is wedding car rental available on weekends and holidays?",
    answer: "Yes, wedding car bookings are available on weekends, holidays, and special occasions with advance reservations."
  },
  {
    question: "How can I book a Wedding Car Rental in Belgaum?",
    answer: "Share your wedding date, pickup location, event schedule, preferred car type, and decoration requirements to receive a customized quotation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rahul Deshmukh",
    feedback: "We booked a wedding car for our special day, and the service was excellent. The car was beautifully decorated, arrived on time, and the chauffeur was very professional.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Patil",
    feedback: "The wedding car rental experience was amazing. The vehicle was premium, clean, and added a beautiful touch to our wedding celebration.",
    rating: 5
  }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Cab Service in Belgaum", link: "Cab-Service-in-Belgaum" },
        { place: "/images/keyword/2.jpg", text: "Belgaum Taxi Service", link: "Belgaum-Taxi-Service" },
        { place: "/images/keyword/3.jpg", text: "Belgaum to Goa Cab", link: "Belgaum-to-Goa-Cab" },
        { place: "/images/keyword/4.jpg", text: "Belgaum to Mahabaleshwar Cab", link: "Belgaum-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Belgaum to Kerala Cab Service", link: "Belgaum-to-Kerala-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Goa to Belgaum Cab", link: "Goa-to-Belgaum-Cab" },
        { place: "/images/keyword/7.jpg", text: "Belgaum to Mumbai Cab", link: "Belgaum-to-Mumbai-Cab" },
        { place: "/images/keyword/8.jpg", text: "Belgaum to Bangalore Cab", link: "Belgaum-to-Bangalore-Cab" },
        { place: "/images/keyword/9.jpg", text: "Goa Cab Service", link: "Goa-Cab-Service" },
        { place: "/images/keyword/10.jpg", text: "Taxi Service in Goa", link: "Taxi-Service-in-Goa" },
        { place: "/images/keyword/11.jpg", text: "Cheapest Cab Service in Goa", link: "Cheapest-Cab-Service-in-Goa" },
        { place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Belgaum", link: "Corporate-Cab-Services-in-Belgaum" },
        { place: "/images/keyword/13.jpg", text: "Innova Crysta Rent in Belgaum", link: "Innova-Crysta-Rent-in-Belgaum" },
        { place: "/images/keyword/14.jpg", text: "Ertiga on Rent in Belgaum", link: "Ertiga-on-Rent-in-Belgaum" },
        { place: "/images/keyword/15.jpg", text: "Tempo Traveller Rent in Belgaum", link: "Tempo-Traveller-Rent-in-Belgaum" },
        { place: "/images/keyword/16.jpg", text: "Mini Bus Rental Belgaum", link: "Mini-Bus-Rental-Belgaum" },
        { place: "/images/keyword/17.jpg", text: "Swift Dzire on Rent in Belgaum", link: "Swift-Dzire-on-Rent-in-Belgaum" },
        { place: "/images/keyword/18.jpg", text: "Urbania on Rent in Belgaum", link: "Urbania-on-Rent-in-Belgaum" },
        { place: "/images/keyword/19.jpg", text: "Wedding Car Rental in Belgaum", link: "Wedding-Car-Rental-in-Belgaum" },
        { place: "/images/keyword/20.jpg", text: "Cabs in Belgaum", link: "Cabs-in-Belgaum" },
        { place: "/images/keyword/21.jpg", text: "Belgaum to Hubli Cab", link: "Belgaum-to-Hubli-Cab" },
        { place: "/images/keyword/22.jpg", text: "Belgaum to Dharwad Cab", link: "Belgaum-to-Dharwad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Belgaum to Kolhapur Cab", link: "Belgaum-to-Kolhapur-Cab" },
        { place: "/images/keyword/24.jpg", text: "Belgaum Airport Cab Service", link: "Belgaum-Airport-Cab-Service" },
        { place: "/images/keyword/25.jpg", text: "Belgaum to Bagalkot Cab", link: "Belgaum-to-Bagalkot-Cab" },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Wedding Car Rental in Belgaum",
  "image": "https://www.belgaumtaxiservice.com/assets/images/wedding-car-rental-in-belgaum.webp",
  "description":
    "Book Wedding Car Rental in Belgaum with Belgaum Taxi Service for premium and stylish wedding transportation. We provide luxury wedding cars, bridal cars, and chauffeur-driven vehicles for weddings, receptions, and special occasions with professional drivers available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Belgaum Taxi Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.belgaumtaxiservice.com/wedding-car-rental-in-belgaum"
  }
};



    return (
        <div>



<Helmet>
  <title>Wedding Car Rental in Belgaum | Luxury Wedding Car | +91 8722158435</title>

  <meta
    name="description"
    content="Book Wedding Car Rental in Belgaum with Belgaum Taxi Service for luxury wedding transportation. Hire premium cars and bridal cars for weddings, receptions, and special events with professional chauffeurs available 24x7."
  />

  <meta
    name="keywords"
    content="Wedding Car Rental in Belgaum, Wedding Car Hire in Belgaum, Wedding Car on Rent in Belgaum, Luxury Wedding Car Rental Belgaum, Bridal Car Rental Belgaum, Wedding Car Booking Belgaum, Luxury Car Hire for Wedding Belgaum, Wedding Taxi Service Belgaum, Premium Wedding Car Belgaum"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>






            <div className="page-headder bg-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="page-header-box text-white">
                                <h1 className="text-anime-style-3 text-center text-white">
                                    {cardData.keyword}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/19.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Belgaum Taxi Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Belgaum Taxi Service</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Belgaum Taxi Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918722158435 " className="pc-call">+91 8722158435 </a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918722158435 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918722158435 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@belgaumtaxiservice.com" className="pc-email">
                                            booking@belgaumtaxiservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Belgaum Taxi Service</strong><br />
                                            P No 30 cCTS No 7023,
                                            Sector No 9 Malmaruti Anjaneya Nagar,
                                            Belgaum, Karnataka - 590017




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Weddingcarrenatalinbelgaum;